import $ from 'jquery';

export default class {
    constructor() {
        this.init();
    }

    init() {
        if ($('#recipe-nav').length > 0) {

            let offset = 200;

            $('body').scrollspy({
                offset: offset,
                target: '#recipe-nav',
            });

            $('.nav a').click(function () {
                const target = $(this.getAttribute('href'));
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - offset + 5,
                    }, 200);
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./scripts/modules/recipePageScroll.js